import React from "react";
import PropTypes from "prop-types";
import { Input, Label } from "lib/components/Form";

export default class InputRow extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired, // one of prop
    required: PropTypes.bool,
  };

  render() {
    let {
      name,
      type,
      inputValue,
      placeholder,
      cssClass,
      defaultValue,
      required,
      label,
    } = this.props;

    return (
      <div className="input-box">
        <Label htmlFor={name} className="required" label={label} />
        <Input
          id={name}
          name={name}
          type={type}
          inputValue={inputValue}
          className=""
          placeholder={placeholder}
          defaultValue={defaultValue}
          required={required}
        />
      </div>
    );
  }
}

InputRow.defaultProps = {
  name: "",
  label: "",
  type: "text",
  required: false,
};
